/** Fade in content that replaces a loading skeleton. */
export const LOADING_REVEAL_CLASSNAME = "motion-safe:animate-in motion-safe:fade-in-0 motion-safe:duration-300";
